import React, { useState, useEffect } from "react";
import {
  Box,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import { Logout, CalendarToday, Language, Business } from "@mui/icons-material";
import { useAppContext } from "../../AppContext";
import MPLoginWithPhoneNumberModal from "./MPLoginWithPhoneNumberModal";
import { useTranslation } from "react-i18next";
import Blogo2 from "../../Images/Blogo2.png";
import user2 from "../../Images/user2.png";
import languagebutton from "../../Images/languagebutton.png";
import { useHistory } from "react-router-dom";
import Bokahitlogo2nobgc from "../../Images/Bokahitlogo2nobgc.png";

export default function MPHeader1() {
  const history = useHistory();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t, i18n } = useTranslation();
  const { User, setUser } = useAppContext();
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [langAnchorEl, setLangAnchorEl] = useState(null);
  const userMenuOpen = Boolean(anchorEl);
  const langMenuOpen = Boolean(langAnchorEl);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, [setUser]);

  const handleLoginClick = () => {
    setLoginModalOpen(true);
  };

  const handleCloseLoginModal = () => {
    setLoginModalOpen(false);
  };

  const handleUserMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLangMenuClick = (event) => {
    setLangAnchorEl(event.currentTarget);
  };

  const handleLangMenuClose = () => {
    setLangAnchorEl(null);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", JSON.stringify(lang));
    localStorage.setItem("hasVisited", "true");
    handleLangMenuClose();
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    handleUserMenuClose();
  };

  const handleMyAppointments = () => {
    history.push(`/client-appointments`);
    handleUserMenuClose();
  };

  const handleListBusiness = () => {
    // Add your list business logic here
    console.log("List your business clicked");
    history.push(`/landing-page`);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
          padding: windowWidth <= 1024 ? "none" : "16px 24px",
          position: "relative",
          paddingTop: windowWidth <= 1024 ? 15 : 5,
          paddingRight: windowWidth <= 1024 ? 15 : 0,
          paddingBottom: windowWidth <= 1024 ? 5 : 0,
        }}
      >
        {windowWidth <= 1024 ? (
          <></>
        ) : (
          <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
            <div
              onClick={handleLangMenuClick}
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                borderRadius: 20,
                borderWidth: 1,
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              {/* Language Selector */}
              <img
                src={languagebutton}
                alt="User"
                style={{
                  width: "20px",
                  height: "20px",
                  objectFit: "contain",
                }}
              />
              <a style={{ textAlign: "center", fontSize: 13, paddingLeft: 5 }}>
                {i18n.language === "sv"
                  ? "Svenska"
                  : i18n.language === "en"
                    ? "English"
                    : "العربية"}
              </a>
            </div>
          </div>
        )}
        {/* Left side - List Your Business Button */}

        {/* Center - Logo */}
        <div
          style={
            {
              // position: "absolute",
              // left: "50%",
              // transform: "translateX(-50%)",
            }
          }
        >
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            <img
              src={Bokahitlogo2nobgc}
              alt="Bokahit"
              style={{
                height: windowWidth <= 1024 ? "35px" : "45px",
                objectFit: "contain",
              }}
            />
          </a>
        </div>

        {/* Right side - Language Selector & User/Login */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          {windowWidth <= 1024 ? (
            <></>
          ) : (
            <button
              style={{
                display: "flex",
                //backgroundColor: "#0891b2",
                //color: "#fff",
                border: "none",
                padding: "5px 10px",
                fontSize: "13px",
                borderRadius: "50px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(8, 145, 178, 0.3)",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
              onClick={handleListBusiness}
              onMouseEnter={(e) => {
                //e.target.style.backgroundColor = "#0e7490";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(8, 145, 178, 0.4)";
              }}
              onMouseLeave={(e) => {
                //e.target.style.backgroundColor = "#0891b2";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(8, 145, 178, 0.3)";
              }}
            >
              <Business sx={{ fontSize: "18px" }} />
              {t("ListYourBusiness") || "List Your Business"}
            </button>
          )}

          {/* User/Login */}
          {User ? (
            <div
              onClick={handleUserMenuClick}
              style={{
                display: "flex",
                //backgroundColor: "#0891b2",
                //color: "#fff",
                border: "none",
                padding: "5px 10px",
                fontSize: "13px",
                borderRadius: "50px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(8, 145, 178, 0.3)",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                fontSize: 13,
              }}
              onMouseEnter={(e) => {
                //e.target.style.backgroundColor = "#0e7490";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(8, 145, 178, 0.4)";
              }}
              onMouseLeave={(e) => {
                //e.target.style.backgroundColor = "#0891b2";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(8, 145, 178, 0.3)";
              }}
            >
              {windowWidth <= 1024 ? (
                <></>
              ) : (
                <img
                  src={user2}
                  alt="User"
                  style={{
                    width: "18px",
                    height: "18px",
                    objectFit: "contain",
                    marginRight: 5,
                  }}
                />
              )}

              {User.name || t("user")}
            </div>
          ) : (
            <button
              onClick={handleLoginClick}
              style={{
                display: "flex",
                //backgroundColor: "#0891b2",
                //color: "#fff",
                border: "none",
                padding: "5px 10px",
                fontSize: "13px",
                borderRadius: "50px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 8px rgba(8, 145, 178, 0.3)",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
              onMouseEnter={(e) => {
                //e.target.style.backgroundColor = "#0e7490";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(8, 145, 178, 0.4)";
              }}
              onMouseLeave={(e) => {
                //e.target.style.backgroundColor = "#0891b2";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 2px 8px rgba(8, 145, 178, 0.3)";
              }}
            >
              <img
                src={user2}
                alt="User"
                style={{
                  width: "20px",
                  height: "20px",
                  objectFit: "contain",
                  marginRight: 8,
                }}
              />
              {t("Login") || "Log in"}
            </button>
          )}
        </div>
      </div>

      {/* Language Menu */}
      <Menu
        anchorEl={langAnchorEl}
        open={langMenuOpen}
        onClose={handleLangMenuClose}
        PaperProps={{
          elevation: 3,
          sx: {
            minWidth: 150,
            borderRadius: 2,
            mt: 1.5,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => handleLanguageChange("sv")}
          selected={i18n.language === "sv"}
        >
          <ListItemIcon>
            <Language fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2" fontWeight="500">
            Svenska
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => handleLanguageChange("en")}
          selected={i18n.language === "en"}
        >
          <ListItemIcon>
            <Language fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2" fontWeight="500">
            English
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={() => handleLanguageChange("ar")}
          selected={i18n.language === "ar"}
        >
          <ListItemIcon>
            <Language fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2" fontWeight="500">
            العربية
          </Typography>
        </MenuItem>
      </Menu>

      {/* User Menu */}
      <Menu
        anchorEl={anchorEl}
        open={userMenuOpen}
        onClose={handleUserMenuClose}
        onClick={handleUserMenuClose}
        PaperProps={{
          elevation: 0,
          sx: {
            minWidth: 240,
            borderRadius: 3,
            mt: 1.5,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
            overflow: "visible",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
              borderLeft: "1px solid",
              borderTop: "1px solid",
              borderColor: "divider",
            },
            "& .MuiMenuItem-root": {
              px: 2,
              py: 1.25,
              borderRadius: 1.5,
              mx: 1,
              my: 0.5,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "rgba(8, 145, 178, 0.08)",
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* User Info Header */}
        <Box
          sx={{
            px: 2.5,
            py: 2,
            mb: 0.5,
            borderRadius: "12px 12px 0 0",
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "radial-gradient(circle at top right, rgba(255,255,255,0.2) 0%, transparent 60%)",
              pointerEvents: "none",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              position: "relative",
            }}
          >
            <Avatar
              sx={{
                bgcolor: "#fff",
                color: "#0891b2",
                width: 44,
                height: 44,
                fontWeight: "700",
                fontSize: "18px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              {User?.name?.charAt(0).toUpperCase() || "U"}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="subtitle2"
                fontWeight="600"
                sx={{
                  mb: 0.25,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {User?.name || t("User")}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  fontSize: "12px",
                }}
              >
                {User?.phoneNumber}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 1 }} />

        {/* Menu Items */}
        <MenuItem
          onClick={handleMyAppointments}
          sx={{
            "&:hover .menu-icon": {
              transform: "scale(1.1)",
            },
          }}
        >
          <ListItemIcon>
            <CalendarToday
              className="menu-icon"
              fontSize="small"
              sx={{
                color: "#667eea",
                transition: "transform 0.2s ease",
              }}
            />
          </ListItemIcon>
          <Typography variant="body2" fontWeight="500">
            {t("MyAppointments") || "My Appointments"}
          </Typography>
        </MenuItem>

        <Divider sx={{ my: 1 }} />

        <MenuItem
          onClick={handleLogout}
          sx={{
            "&:hover": {
              backgroundColor: "rgba(239, 68, 68, 0.08) !important",
            },
            "&:hover .menu-icon": {
              transform: "scale(1.1)",
            },
          }}
        >
          <ListItemIcon>
            <Logout
              className="menu-icon"
              fontSize="small"
              sx={{
                color: "#ef4444",
                transition: "transform 0.2s ease",
              }}
            />
          </ListItemIcon>
          <Typography variant="body2" fontWeight="500" color="error">
            {t("Logout") || "Logout"}
          </Typography>
        </MenuItem>
      </Menu>
      <MPLoginWithPhoneNumberModal
        open={loginModalOpen}
        onClose={handleCloseLoginModal}
      />
    </>
  );
}
